import React, { useContext, useState, useEffect } from 'react';
import { H4 } from '../../components/Typography/styles';
import {
  ClientsContainer,
  ClientsWrapper,
  ClientsHeader,
  ClientsHaderTitle,
  FadeContainer,
  ClientsEmptyStateContainer,
  ClientsEmptyStateParagraph
} from './styles';
import { SessionContext } from '../../store';
import { sortByDate } from '../../helpers/sort';
import { getClientList } from '../../services/clients';
import { distinctByDescription } from '../../helpers/distinct';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import Filter from '../../components/Filter';
import GridRowCardClient from '../../components/GridRowCardClient';
import Copyright from '../../components/Copyright';
import colors from '../../assets/styles/colors';
import Loader from '../../components/Loader';
import emptyState from '../../assets/images/empty.svg';

const ClientListPage = () => {
  const session = useContext(SessionContext);
  const [completeListClients, setCompleteListClients] = useState([]);
  const [clients, setClients] = useState([]);
  const [currentClients, setCurrentClients] = useState([]);
  const [statusDescription, setStatusDescription] = useState([]);
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [orderByCurrent, setOrderByCurrent] = useState(false);
  const [showByExpand, setShowByExpand] = useState(false);
  const [gridByRow, setGridByRow] = useState(false);
  const [showBy, setShowBy] = useState('Todos');
  const [fadeToggle, setFadeToggle] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(6);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  
  const paginate = pageNumber => setCurrentPage(pageNumber);

  async function initializeStateSolicitations() {
    try {
      const clients = await getClientList(session.idAsesor);

      clients.data.data.forEach(item => {
        item.fecha = item.fechaNacimiento
      })

      let newStatus = distinctByDescription([]);

      newStatus = newStatus.map(status => {
        return {
          label: status
        }
      });

      setStatusDescription(newStatus);
      setCompleteListClients(sortByDate(clients.data.data, orderByCurrent));
      setTimeOutFade(false);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error)
      console.log(error.response)
    }
  }

  function setTimeOutFade(bool) {
    setFadeToggle(false);
    setIsLoading(false);

    setTimeout(() => {
      setGridByRow(bool);
      setFadeToggle(true);
    }, 200)
  }

  function handlePageClick(data) {
    let selected = data.selected + 1;

    paginate(selected);
  }

  useEffect(() => {
    let clientsArr = completeListClients;

    if (search.length) {
      clientsArr = clientsArr.filter(client => client.identificacion.indexOf(search) > -1 || client.nombres.toLowerCase().indexOf(search.toLocaleLowerCase()) > -1);
    }

    if (showBy !== 'Todos') {
      clientsArr = clientsArr.filter(client => client?.estado.descripcion === showBy);
    }

    clientsArr = sortByDate(clientsArr, orderByCurrent);
    setClients(clientsArr);
    setCurrentClients(clientsArr.slice(indexOfFirstPost, indexOfLastPost));
  }, [completeListClients, orderByCurrent, currentPage, showBy, gridByRow, search]);

  useEffect(() => {
    initializeStateSolicitations();

    return () => {
      setClients([]);
      setCompleteListClients([]);
      setStatusDescription([]);
      setCurrentClients([]);
    };
  }, []);

  return (
    <ClientsContainer id="clients-page">
      <ClientsWrapper>
        <ClientsHeader>
          <ClientsHaderTitle>Novedades</ClientsHaderTitle>
          <H4 color={colors.textPrimary}>Modificar Datos</H4>
        </ClientsHeader>
        <Filter
          orderByCurrent={orderByCurrent} setOrderByCurrent={setOrderByCurrent}
          showByExpand={showByExpand} setShowByExpand={setShowByExpand}
          showBy={showBy} setShowBy={setShowBy}
          gridByRow={gridByRow} setGridByRow={setGridByRow}
          setSearch={setSearch}
          statusDescription={statusDescription}
          setTimeOutFade={setTimeOutFade} />
        {!completeListClients.length ? (
          <ClientsEmptyStateContainer>
            <img src={emptyState} alt="Empty state" />
            <ClientsEmptyStateParagraph>
            No hay información para visualizar
            </ClientsEmptyStateParagraph>
          </ClientsEmptyStateContainer>
        ) : ''}
        <FadeContainer fade={fadeToggle} id="fade">
          {gridByRow ? (
            currentClients.map((item, key) => (
              <GridRowCardClient key={key} item={item}/>
            ))
          ) : (
            currentClients.map((item, key) => (
              <GridRowCardClient key={key} item={item}/>
            ))
          )}
          {completeListClients.length ? (
          <ReactPaginate
            previousLabel={<MdKeyboardArrowLeft size={28} id="arrow-left-icon" />}
            nextLabel={<MdKeyboardArrowRight size={28} id="arrow-right-icon" />}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={Math.ceil(clients.length / postsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={1}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            activeClassName={'active'}
          /> ) : ''}
        </FadeContainer>
        {isLoading && <Loader />}
      </ClientsWrapper>
      <Copyright />
    </ClientsContainer>
  )
}

export default ClientListPage
